import React from 'react';
import { PaginationWrapper } from './PaginationWrapper';
import { PaginationListType } from '../../Types/PaginationParams';
import PaginationSearchFilter from './PaginationSearchFilter';

interface PaginatedViewRenderProps {
    filter: React.ReactNode;
    list: React.ReactNode;
    queryString: string | null;
    totalItems: number;
    itemsPerPage: number;
}

interface PaginatedViewProps<T> {
    itemsPerPage?: number;
    listType: PaginationListType;
    renderItem: (item: T, index: number) => React.ReactNode;
    listClassName?: string;
    filterClassName?: string;
    itemsFunction: (
        page: number,
        itemsPerPage: number,
        optionalParams?: Record<string, string>,
        query?: string | null,
    ) => Promise<{ data: { data: T[]; total: number } }> | any;
    children: (props: PaginatedViewRenderProps) => React.ReactNode;
}

function PaginatedView<T>({
    itemsFunction,
    renderItem,
    listType,
    itemsPerPage = 7,
    listClassName = '',
    filterClassName = 'mb-16',
    children,
}: PaginatedViewProps<T>) {
    const [totalItems, setTotalItems] = React.useState(0);
    return (
        <PaginationSearchFilter className={filterClassName} listType={listType}>
            {(filterNode: any, queryString: string | null) => {
                const list = (
                    <PaginationWrapper<T>
                        setTotalItems={(total: number) => {
                            setTotalItems(total);
                        }}
                        totalItems={totalItems}
                        listType={listType}
                        itemsFunction={itemsFunction}
                        itemsPerPage={itemsPerPage}
                        query={queryString ?? null}
                        renderItem={renderItem}
                        className={listClassName}
                    />
                );

                return (
                    <>
                        {children({
                            filter: filterNode,
                            list,
                            queryString,
                            totalItems,
                            itemsPerPage,
                        })}
                    </>
                );
            }}
        </PaginationSearchFilter>
    );
}

export default PaginatedView;
